const comments = [
  {
    name: '星之卡比',
    text: '用了三年51漫画网了，从来没遇到过恶意跳转和广告弹窗，界面干净体验好，追更速度也很快，真心推荐给所有漫迷朋友！',
    tag: '资深用户',
  },
  {
    name: '漫画狂热者',
    text: '之前试过好多平台，要么画质糊要么更新慢。51漫画网页版真的香，高清加载毫无压力，收藏功能也很方便，现在已经离不开了。',
    tag: '忠实粉丝',
  },
  {
    name: '夜雨声烦',
    text: '最喜欢它的分类做得特别细致，冷门佳作也能找到。手机端网页版适配也很好，睡前躺着看漫画太享受了，51漫画网址收藏了。',
    tag: '活跃读者',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            读者心声
          </h2>
          <p className="text-sm text-foreground-500">来自51漫画网用户的真实反馈</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-6">
              <div className="flex items-center gap-2 mb-4 text-accent-500">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div key={star} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm"></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                &ldquo;{item.text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100/80 flex items-center justify-center">
                  <span className="text-sm font-medium text-primary-700">{item.name.charAt(0)}</span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.tag}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}